/** Amplitude ratio for a level in dB (20·log10 convention). `-Infinity` maps to 0. */
export function dbToGain(db: number): number {
  return Math.pow(10, db / 20);
}

/** Level in dB of an amplitude ratio. Zero and negative gains map to `-Infinity`. */
export function gainToDb(gain: number): number {
  return gain > 0 ? 20 * Math.log10(gain) : -Infinity;
}
